var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container" },
    [
      _c(
        "el-card",
        {
          staticClass: "statistics-cards-container",
          attrs: { shadow: "hover" },
        },
        [
          _c(
            "el-row",
            { attrs: { gutter: 20 } },
            [
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card project-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-tickets" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val": _vm.stats.total || 0,
                            duration: 2000,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("总交易笔数"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card income-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-top" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _vm._v("¥\n              "),
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val": Number(_vm.stats.incr || 0),
                            duration: 2000,
                            decimals: 2,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("收入总额"),
                    ]),
                  ]),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 8 } }, [
                _c("div", { staticClass: "stat-card expense-card" }, [
                  _c("div", { staticClass: "stat-icon" }, [
                    _c("i", { staticClass: "el-icon-bottom" }),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "stat-content" }, [
                    _c(
                      "div",
                      { staticClass: "stat-value" },
                      [
                        _vm._v("¥\n              "),
                        _c("count-to", {
                          attrs: {
                            "start-val": 0,
                            "end-val": Number(_vm.stats.used || 0),
                            duration: 2000,
                            decimals: 2,
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "stat-label" }, [
                      _vm._v("支出总额"),
                    ]),
                  ]),
                ]),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("el-card", { attrs: { shadow: "never" } }, [
        _c(
          "div",
          { staticClass: "filter-header" },
          [
            _c("span", { staticClass: "filter-title" }, [_vm._v("高级搜索")]),
            _vm._v(" "),
            _c(
              "el-button",
              {
                staticClass: "filter-toggle",
                attrs: { type: "text" },
                on: {
                  click: function ($event) {
                    _vm.isFilterCollapsed = !_vm.isFilterCollapsed
                  },
                },
              },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.isFilterCollapsed ? "展开筛选" : "收起筛选") +
                    "\n        "
                ),
                _c("i", {
                  class: [
                    _vm.isFilterCollapsed
                      ? "el-icon-arrow-down"
                      : "el-icon-arrow-up",
                  ],
                }),
              ]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "filter-container",
            class: { "is-collapsed": _vm.isFilterCollapsed },
          },
          [
            _c(
              "el-form",
              {
                ref: "searchForm",
                attrs: {
                  inline: true,
                  model: _vm.listParams,
                  "label-width": "100px",
                  size: "small",
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "交易流水号", prop: "orderNo" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入交易流水号", clearable: "" },
                      model: {
                        value: _vm.listParams.orderNo,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "orderNo", $$v)
                        },
                        expression: "listParams.orderNo",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "卡片编号", prop: "empIntegralId" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入卡片编号", clearable: "" },
                      model: {
                        value: _vm.listParams.empIntegralId,
                        callback: function ($$v) {
                          _vm.$set(_vm.listParams, "empIntegralId", $$v)
                        },
                        expression: "listParams.empIntegralId",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "项目名称", prop: "projectId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: {
                          placeholder: "请选择项目",
                          clearable: "",
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.searchProjects,
                          loading: _vm.projectsLoading,
                        },
                        on: {
                          "visible-change": function (val) {
                            return val && _vm.fetchInitialProjects()
                          },
                        },
                        model: {
                          value: _vm.listParams.projectId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "projectId", $$v)
                          },
                          expression: "listParams.projectId",
                        },
                      },
                      [
                        _vm._l(_vm.projectOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        _vm._v(" "),
                        !_vm.projectsNoMore
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.projectsLoadingMore,
                                    expression: "projectsLoadingMore",
                                  },
                                ],
                                staticClass: "loading-more",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.loadMoreProjects($event)
                                  },
                                },
                              },
                              [_vm._v("\n              加载更多\n            ")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "小程序", prop: "appId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: {
                          placeholder: "请选择小程序",
                          clearable: "",
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.searchMiniapps,
                          loading: _vm.miniappsLoading,
                        },
                        on: {
                          "visible-change": function (val) {
                            return val && _vm.fetchInitialMiniapps()
                          },
                        },
                        model: {
                          value: _vm.listParams.appId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "appId", $$v)
                          },
                          expression: "listParams.appId",
                        },
                      },
                      [
                        _vm._l(_vm.appOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        _vm._v(" "),
                        !_vm.miniappsNoMore
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.miniappsLoadingMore,
                                    expression: "miniappsLoadingMore",
                                  },
                                ],
                                staticClass: "loading-more",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.loadMoreMiniapps($event)
                                  },
                                },
                              },
                              [_vm._v("\n              加载更多\n            ")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客户", prop: "customerId" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: {
                          placeholder: "请选择客户",
                          clearable: "",
                          filterable: "",
                          remote: "",
                          "remote-method": _vm.searchCustomers,
                          loading: _vm.customersLoading,
                        },
                        on: {
                          "visible-change": function (val) {
                            return val && _vm.fetchInitialCustomers()
                          },
                        },
                        model: {
                          value: _vm.listParams.customerId,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "customerId", $$v)
                          },
                          expression: "listParams.customerId",
                        },
                      },
                      [
                        _vm._l(_vm.customerOptions, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        _vm._v(" "),
                        !_vm.customersNoMore
                          ? _c(
                              "div",
                              {
                                directives: [
                                  {
                                    name: "loading",
                                    rawName: "v-loading",
                                    value: _vm.customersLoadingMore,
                                    expression: "customersLoadingMore",
                                  },
                                ],
                                staticClass: "loading-more",
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.loadMoreCustomers($event)
                                  },
                                },
                              },
                              [_vm._v("\n              加载更多\n            ")]
                            )
                          : _vm._e(),
                      ],
                      2
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "交易类型", prop: "type" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "220px" },
                        attrs: { placeholder: "请选择交易类型", clearable: "" },
                        on: {
                          "visible-change": function (val) {
                            return val && _vm.loadTypeOptions()
                          },
                        },
                        model: {
                          value: _vm.listParams.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.listParams, "type", $$v)
                          },
                          expression: "listParams.type",
                        },
                      },
                      _vm._l(_vm.typeOptions, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "交易时间", prop: "dateRange" } },
                  [
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "range-separator": "至",
                        "start-placeholder": "开始日期",
                        "end-placeholder": "结束日期",
                        "value-format": "yyyy-MM-dd",
                        "default-time": ["00:00:00", "23:59:59"],
                      },
                      model: {
                        value: _vm.dateRange,
                        callback: function ($$v) {
                          _vm.dateRange = $$v
                        },
                        expression: "dateRange",
                      },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", icon: "el-icon-search" },
                        on: { click: _vm.getList },
                      },
                      [_vm._v("查询")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { icon: "el-icon-refresh" },
                        on: { click: _vm.resetForm },
                      },
                      [_vm._v("重置")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "success", icon: "el-icon-download" },
                        on: { click: _vm.exportData },
                      },
                      [_vm._v("导出")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: {
                          type: "info",
                          icon: "el-icon-refresh-right",
                          title: "刷新数据 (Ctrl+R)",
                        },
                        on: { click: _vm.getList },
                      },
                      [_vm._v("刷新")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "10px" }, attrs: { shadow: "never" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticClass: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "id",
                  label: "ID",
                  width: "80",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "orderNo",
                  label: "交易流水号",
                  "min-width": "150",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empIntegralId",
                  label: "卡片编号",
                  "min-width": "100",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "projectName",
                  label: "项目名称",
                  "min-width": "150",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "交易类型",
                  "min-width": "120",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getTypeTag(scope.row.type),
                              size: "small",
                            },
                          },
                          [
                            _c("i", {
                              class: _vm.getTypeIcon(scope.row.type),
                              staticStyle: { "margin-right": "5px" },
                            }),
                            _vm._v(
                              "\n            " +
                                _vm._s(scope.row.typeName) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "交易金额",
                  "min-width": "120",
                  align: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            class:
                              Number(scope.row.integral) > 0
                                ? "income-text"
                                : "expense-text",
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(
                                  Number(scope.row.integral) > 0 ? "+" : ""
                                ) +
                                "¥" +
                                _vm._s(_vm.formatMoney(scope.row.integral)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cardName",
                  label: "卡片名称",
                  "min-width": "150",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "appName",
                  label: "小程序",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "empName",
                  label: "用户姓名",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "phone",
                  label: "手机号",
                  "min-width": "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "交易时间",
                  "min-width": "180",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.createTime))]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "remark",
                  label: "备注",
                  "min-width": "150",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.listParams.page,
              "page-sizes": [20, 40, 60, 80, 100],
              "page-size": _vm.listParams.limit,
              layout: "total, sizes, prev, pager, next, jumper",
              total: _vm.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }